import { Stack, Typography } from '@mui/material';
import React from 'react';

export const NotificationContent = ({
  title,
  children,
}: {
  title: string;
  children: React.ReactChild | React.ReactChildren;
}) => {
  return (
    <Stack spacing={0}>
      <Typography
        component="h1"
        sx={{ fontSize: '1rem', fontWeight: '700', margin: '0' }}
      >
        {title}
      </Typography>
      {children}
    </Stack>
  );
};
